import { Link } from "react-router-dom";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKBadge from "components/MKBadge";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import { useTranslation } from "react-i18next";

// You can use your own image here
const bannerImage =
  "https://images.unsplash.com/photo-1512918728675-ed5a9ecdebfd?auto=format&fit=crop&w=1200&q=80";

function Pages() {
  const { t } = useTranslation();
  return (
    <MKBox component="section" py={8} sx={{ backgroundColor: "#f8f9fa" }}>
      <Container>
        <Grid container justifyContent="center" spacing={4}>
          <Grid item xs={12} md={10} lg={8}>
            <MKBox
              component="img"
              src={bannerImage}
              alt="Grow your business"
              width="100%"
              borderRadius="lg"
              mb={4}
              sx={{
                boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
                maxHeight: 150,
                objectFit: "cover",
              }}
            />
          </Grid>
          <Grid item xs={12} lg={8}>
            <Grid
              container
              flexDirection="column"
              alignItems="center"
              sx={{ textAlign: "center", my: 1, mx: "auto", px: 0.75 }}
            >
              <MKBadge
                variant="contained"
                color="info"
                badgeContent={t("whyChooseUs.boostYourBuissiness")}
                container
                sx={{ mb: 2 }}
              />
              <MKTypography variant="h2" fontWeight="bold" mb={1}>
                {t("whyChooseUs.highlightTitle")}
              </MKTypography>
              <MKTypography variant="body1" color="text" mb={3}>
                {t("whyChooseUs.highlightText")}
              </MKTypography>
            </Grid>
          </Grid>
          {/* Bottom Information Section */}
          <Grid item xs={12} lg={8}>
            <MKBox
              py={4}
              px={3}
              borderRadius="lg"
              sx={{
                background: "white",
                boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
                textAlign: "center",
              }}
            >
              <MKTypography variant="h5" color="info" mb={2}>
                {t("ready")}
              </MKTypography>
              <MKTypography variant="body2" color="text" mb={3}>
                {t("readyDescription")}
              </MKTypography>
              <MKBox
                display="flex"
                justifyContent="center"
                gap={4} // Adjust the gap as needed (e.g., 2 = 16px)
                mt={2}
                sx={{
                  flexDirection: { xs: "column", sm: "row" }, // column on xs, row on sm and up
                  alignItems: "center",
                }}
              >
                <MKButton
                  component={Link}
                  to="/Services/OurServices"
                  color="info"
                  size="large"
                  variant="gradient"
                >
                  {t("viewOurServices")}
                </MKButton>
                <MKButton
                  component={Link}
                  to="/pages/landing-pages/contact-us"
                  color="info"
                  size="large"
                  variant="gradient"
                >
                  {t("contactUs")}
                </MKButton>
              </MKBox>
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Pages;
